import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PauseRegular from './pause-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PauseRegular {...validProps} />;
}

SvgComponent.iconName = 'pauseRegular';

export const PauseRegularIcon = svgIconWrapper(SvgComponent);
